import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { PlannerEndpoints } from '../constants/planner-endpoints.const';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private http: HttpClient) { }

  prepareExportData(planId: string) {
    const endpoint = PlannerEndpoints.planInventoryAllocationExport + planId;
    return this.http.get(
      endpoint,
      { responseType: 'blob' }
    ).toPromise().then((resp) => {
      return resp;
    });
  }

  public exportInventoryAllocationData(planId: string): Promise<any> {
    return this.prepareExportData(planId).then((resp: any) => {
      this.downloadExcel(planId + '_Inventory_Allocation.csv', resp);
    });
  }

  downloadExcel(fileName, resp) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }

}